import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser';

const spaClientId =
  import.meta.env.VITE_ENTRA_SPA_CLIENT_ID ||
  import.meta.env.VITE_ENTRA_CLIENT_ID ||
  '';

const apiClientId =
  import.meta.env.VITE_ENTRA_API_CLIENT_ID ||
  import.meta.env.VITE_ENTRA_CLIENT_ID ||
  '';

const configuredApiScope = import.meta.env.VITE_ENTRA_API_SCOPE || '';
const defaultApiScope = apiClientId ? `api://${apiClientId}/access` : '';

const msalConfig: Configuration = {
  auth: {
    clientId: spaClientId,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error(message);
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const apiScope = configuredApiScope || defaultApiScope;

export const loginRequest = {
  scopes: [apiScope],
};
